module.exports = __webpack_public_path__ + "static/communityintroheader-0acce01dc3410b4ce2d4ec451cfd0048.jpg";